const conpon = [
    {
        path: '/conpon/tast/:id',
        name: 'conponIndex',
        component: () => import('../views/conpon/index.vue'),
    },
    {
        path: '/conpon/list',
        name: 'conponList',
        component: () => import('../views/conpon/list.vue'),
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/points',
        name: 'ponintsDetail',
        component: () => import('../views/conpon/points.vue'),
        meta:{
            keepAlive:true
        }
    },
    {
        path: '/points/goods/:id',
        name: 'ponintsGoods',
        component: () => import('../views/conpon/points-goods-detail.vue'),
    },
    {
        path: '/points/list/:patientId',
        name: 'ponintsList',
        component: () => import('../views/conpon/points-list.vue'),
    },
    {
        path: '/conpon/detail/:id',
        name: 'conponDetailItem',
        component: () => import('../views/conpon/detail.vue'),
    },
    {
        path: '/points/log/:patientId',
        name: 'ponintsLog',
        component: () => import('../views/conpon/points-log.vue'),
    },
    {
        path: '/task/list',
        name: 'taskList',
        component: () => import('../views/conpon/task-list.vue'),
    }
]
export default conpon



// WEBPACK FOOTER //
// ./src/router/conpon.js